<span class="value" *ngIf="value != null" translate="allowedMileage"
      [translateParams]="{ mileage: this.value | localeNumber }"></span>
